/* eslint-disable react-hooks/exhaustive-deps */
import { Button, useMediaQuery, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

export type buttonStatus = "validado" | "completo" | "editar" | "llenar";

export interface buttonProps {
  disabled: boolean;
  buttonLabel: string;
  backgroundColor: string;
  color?: string;
}

export interface ButtonValidacionIdentidadProps {
  isCompleted?: boolean | null;
  documentStatus?: boolean | null;
  fakeDisabled?: boolean;
  onClick?: () => void;
}

const ButtonValidacionIdentidad: React.FC<ButtonValidacionIdentidadProps> = ({
  isCompleted,
  documentStatus,
  fakeDisabled,
  onClick,
}) => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const [btnParams, setBtnParams] = useState<buttonProps>({
    disabled: false,
    buttonLabel: "Llenar",
    backgroundColor: theme?.palette?.primary?.main,
    color: theme?.palette?.otherColors?.main,
  });

  const generateButtonParams = () => {
    let btnParams: buttonProps = {
      disabled: false,
      buttonLabel: "Validar",
      backgroundColor: theme?.palette?.primary?.main,
      color: "#FFFFFF",
    };

    if (isCompleted === true && documentStatus === true) {
      btnParams = {
        disabled: true,
        buttonLabel: "Validado",
        backgroundColor: theme?.palette?.primary?.light,
        color: theme?.palette?.primary?.main,
      };
    } else {
      if (isCompleted === true) {
        btnParams = {
          disabled: true,
          buttonLabel: "Completo",
          backgroundColor: theme?.palette?.primary?.dark,
          color: theme?.palette?.primary?.light,
        };
      } else if (isCompleted === false) {
        btnParams = {
          disabled: false,
          buttonLabel: "Volver a validar",
          backgroundColor: "#F2704F",
          color: "#FFFFFF",
        };
      }
    }

    setBtnParams(btnParams);
  };

  useEffect(() => {
    generateButtonParams();
  }, [isCompleted, documentStatus]);

  return (
    <Button
      variant="expediente"
      size={isMobileOrTablet ? "small" : "medium"}
      onClick={onClick}
      disabled={btnParams.disabled}
      sx={{
        backgroundColor: btnParams.backgroundColor,
        color: btnParams.color,
        opacity: fakeDisabled ? 0.5 : 1,
        ...(isMobileOrTablet
          ? {
              width: "auto",
              maxWidth: "100%",
              height: "auto",
              minHeight: "23px",
              whiteSpace: "normal",
              overflowWrap: "anywhere",
              textAlign: "center",
              lineHeight: 1.15,
              paddingTop: "6px",
              paddingBottom: "6px",
            }
          : null),
        "&:hover": {
          backgroundColor: btnParams.backgroundColor,
        },
        "&.Mui-disabled": {
          backgroundColor: btnParams.backgroundColor,
          color: btnParams.color,
          opacity: 1,
        },
      }}
    >
      {btnParams.buttonLabel}
    </Button>
  );
};

export default ButtonValidacionIdentidad;
